module.exports = __webpack_public_path__ + "static/media/procast-data.cd2bd67e.png";